import { render } from "./AccessBar.vue?vue&type=template&id=3a46658a&scoped=true"
import script from "./AccessBar.vue?vue&type=script&lang=js"
export * from "./AccessBar.vue?vue&type=script&lang=js"

import "./AccessBar.vue?vue&type=style&index=0&id=3a46658a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a46658a"]])

export default __exports__